import { Link } from "wouter";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { buildPhoneHref } from "@/lib/entityLinks";
import { getInitials } from "@/lib/utils";

export interface PersonIdentityDetails {
  avatar?: string | null;
  role?: string | null;
  companyName?: string | null;
  companyHref?: string;
  mobilePhone?: string | null;
  email?: string | null;
  onEmail?: () => void;
}

export function PersonIdentityCard({ name, details }: { name: string; details: PersonIdentityDetails }) {
  const phone = details.mobilePhone?.trim();
  const email = details.email?.trim();
  const companyName = details.companyName?.trim();

  return (
    <div className="flex min-w-0 items-start gap-3" aria-label={`Scheda rapida di ${name}`}>
      <Avatar className="h-14 w-14 border border-border sm:h-16 sm:w-16">
        {details.avatar && <AvatarImage src={details.avatar} alt={`Foto di ${name}`} className="object-cover" />}
        <AvatarFallback className="text-base font-semibold">{getInitials(name)}</AvatarFallback>
      </Avatar>
      <div className="min-w-0 flex-1">
        <h1 className="break-words text-xl font-bold leading-tight sm:text-2xl">{name}</h1>
        <dl className="mt-1 grid min-w-0 gap-x-5 gap-y-0.5 text-sm sm:grid-cols-2">
          <div className="min-w-0"><dt className="inline text-muted-foreground">Ruolo: </dt><dd className="inline break-words">{details.role?.trim() || "Non indicato"}</dd></div>
          <div className="min-w-0"><dt className="inline text-muted-foreground">Azienda: </dt><dd className="inline break-words">{companyName && details.companyHref ? <Link href={details.companyHref} className="font-medium text-primary hover:underline">{companyName}</Link> : companyName || "Non associata"}</dd></div>
          <div className="min-w-0"><dt className="inline text-muted-foreground">Cellulare: </dt><dd className="inline break-all">{phone ? <a href={buildPhoneHref(phone)} className="font-medium text-primary hover:underline">{phone}</a> : "Non indicato"}</dd></div>
          <div className="min-w-0"><dt className="inline text-muted-foreground">Email: </dt><dd className="inline break-all">{email ? details.onEmail ? <button type="button" onClick={details.onEmail} className="text-left font-medium text-primary hover:underline">{email}</button> : email : "Non indicata"}</dd></div>
        </dl>
      </div>
    </div>
  );
}
